interface Props {
  value: number;
  max?: number;
  tone?: "default" | "warn" | "accent";
}

export function MiniBar({ value, max = 1, tone = "default" }: Props) {
  const pct = Math.max(0, Math.min(1, value / max)) * 100;
  return (
    <div className={`bbc-bar bbc-bar-${tone}`}>
      <i style={{ width: pct + "%" }} />
    </div>
  );
}
